import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const SoftwareWorkSuggestionsYourWorkEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(/* webpackChunkName: "async-software-work-suggestions-your-work" */ './src/ui').then(
			(module) => module.SoftwareWorkSuggestionsYourWork,
		),
	),
	getPreloadProps: () => ({}),
});
